<template>
  <div class="board-container">
    <div class="top-table">
      <div class="left-tabs">
        <div
          class="table-item"
          :class="{ active: activeTab === item.route }"
          v-for="item in tabsList"
          :key="item.route"
          @click="handleTabClick(item)"
        >
          <img
            :src="activeTab === item.route ? item.activeIcon : item.inactiveIcon"
            class="tab-icon"
          />
          {{ item.label }}
        </div>
        <div class="tips" v-show="activeTab == '/board/serve'">
          当前界面展示的所有销售额均为在小程序注册后的用户产生，非全部销售额，新注册用户将同步历史销售额
        </div>
      </div>

      <div class="right-user">
        <el-popover
          placement="bottom"
          width="150"
          trigger="click"
          popper-class="user-info-popover"
        >
          <div class="user-info-dropmenu">
            <div class="menu-item" @click="handleEdit">
              <span>修改密码</span>
              <i class="icon-edit"></i>
            </div>
            <div class="menu-item" @click="logoutDialogShow = true">
              <span>退出登录</span>
              <i class="icon-logout"></i>
            </div>
          </div>

          <div class="user-info" slot="reference">
            <p>{{ crmUserMobile }}</p>
            <el-button icon="el-icon-arrow-down"></el-button>
          </div>
        </el-popover>
      </div>
    </div>
    <div class="board-content">
      <router-view></router-view>
    </div>

    <el-dialog
      title="提示"
      :visible.sync="logoutDialogShow"
      width="400px"
      append-to-body
    >
      <p>确定退出登录？</p>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="logoutDialogShow = false"
          >取 消</el-button
        >
        <el-button
          size="small"
          type="primary"
          @click="logoutOnline"
          :loading="logoutLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import commodityActiveIcon from "@/assets/commodity-active-icon.png";
import commodityInactiveIcon from "@/assets/commodity-inactive-icon.png";
import serveActiveIcon from "@/assets/serve-active-icon.png";
import serveInactiveIcon from "@/assets/serve-inactive-icon.png";
import { logout } from "@/common/api";

export default {
  name: "board",
  data() {
    return {
      activeTab: "",
      crmUserMobile: localStorage.getItem("crmUserMobile"),
      logoutDialogShow: false,
      logoutLoading: false,
    };
  },
  computed: {
    tabsList() {
      const idsStr = localStorage.getItem("ids");
      const ids = idsStr ? JSON.parse(idsStr) : [];
      const list = [];

      // 47: 商品订单看板权限
      if (ids.indexOf(47) > -1) {
        list.push({
          label: "商品订单BI",
          route: "/board/commodity",
          activeIcon: commodityActiveIcon,
          inactiveIcon: commodityInactiveIcon,
        });
      }
      // 48: 服务订单看板权限
      if (ids.indexOf(48) > -1) {
        list.push({
          label: "服务订单BI",
          route: "/board/serve",
          activeIcon: serveActiveIcon,
          inactiveIcon: serveInactiveIcon,
        });
      }
      return list;
    },
  },
  watch: {
    $route: {
      handler(route) {
        this.crmUserMobile = localStorage.getItem("crmUserMobile");
        if (route.path.startsWith("/board/commodity")) {
          this.activeTab = "/board/commodity";
        } else if (route.path.startsWith("/board/serve")) {
          this.activeTab = "/board/serve";
        } else {
          this.activeTab = "";
        }
      },
      immediate: true,
    },
  },
  methods: {
    handleTabClick(tab) {
      // 如果当前路由不是点击的路由，则进行页面跳转
      if (this.$route.path !== tab.route) {
        this.$router.push({ path: tab.route });
      }
    },
    handleEdit() {
      this.$router.push({ path: "/permission/personal/form" });
    },
    logoutOnline() {
      this.logoutLoading = true;
      logout()
        .then((res) => {
          if (res.code == 0) {
            this.logoutLoading = false;
            this.logoutDialogShow = false;
            localStorage.clear();
            sessionStorage.removeItem("visitedViews"); // 退出时清空足迹
            this.$message({ message: "退出登陆成功", type: "success" });
            this.$router.push({ path: "/login" });
          } else {
            this.logoutLoading = false;
            this.logoutDialogShow = false;
            this.$message({ message: res.msg, type: "error" });
          }
        })
        .catch((error) => {
          this.logoutLoading = false;
          this.$message.error("服务器异常");
        });
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/common/styles/base/mixin-common";

.board-container {
  min-width: fit-content;

  .top-table {
    width: 100%;
    height: 79px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: 2;
    padding: 0 30px;
    box-sizing: border-box;

    .left-tabs {
      display: flex;
      align-items: center;
      height: 100%;
      flex: 1;

      .table-item {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        padding: 27px 30px 27px 30px;
        box-sizing: border-box;
        font-weight: 500;
        font-size: 16px;
        color: #888888;

        &.active {
          color: #0d6efd;
          padding: 27px 30px 21px 30px;
          border-bottom: 6px solid #0d6efd;
          background: #ebf0fe;
        }

        .tab-icon {
          width: 18px;
          height: 18px;
          margin-right: 8px;
          vertical-align: middle;
          margin-top: 2px;
        }
      }

      .tips {
        height: 100%;
        display: flex;
        align-items: flex-end;
        color: #888888;
        font-size: 12px;
        padding-bottom: 8px;
        margin-left: 10px;
      }
    }

    .right-user {
      display: flex;
      align-items: center;

      .user-info {
        display: flex;
        align-items: center;
        cursor: pointer;

        p {
          position: relative;
          padding: 0 3px 0 21px;
          font-size: 14px;
          line-height: 20px;

          &::before {
            content: "";
            position: absolute;
            z-index: 3;
            top: 2px;
            left: 0;
            width: 16px;
            height: 16px;
            @include backgroundImage(
              "../../assets/icon_16@2x.png",
              no-repeat,
              0,
              0,
              auto,
              16px
            );
          }
        }

        .el-button {
          margin-top: 2px;
          padding: 2px;
          font-size: 12px;
          border: none;
          background: transparent;
        }
      }
    }
  }

  .board-content {
    padding: 10px;
  }
}
</style>
